module.exports = __webpack_public_path__ + "static/waves-1-26aaf58dafce942bfcaa0076fc5c8858.svg";